import React from 'react';
import VoxelTooltipShort from '../../../../../components/voxel/Tooltip/VoxelTooltipShort';

export interface KeywordAvatarProps {
  index: number;
  size?: 'sm' | 'md';
}

const KeywordAvatar: React.FC<KeywordAvatarProps> = React.memo(({ index, size = 'md' }) => {
  const keywordLabelShort = (() => {
    if (index === 0) {
      return 'P';
    } else if (index === 1) {
      return 'S';
    } else if (index > 1 && index < 7) {
      return 'L';
    } else {
      return 'LL';
    }
  })();

  const keywordLabel = (() => {
    if (index === 0) {
      return 'Primary';
    } else if (index === 1) {
      return 'Secondary';
    } else if (index > 1 && index < 7) {
      return 'Longtail';
    } else {
      return 'LongLongtail';
    }
  })();

  let avatarSize = 'w-6 h-6';
  if (size === 'sm') {
    avatarSize = 'w-5 h-5';
  }

  return (
    <VoxelTooltipShort message={keywordLabel}>
      <div
        className={`
        ${avatarSize} rounded-full flex flex-row items-center
        ${index === 0 ? 'bg-primary-600' : ''}
        ${index === 1 ? 'bg-primary-500' : ''}
        ${index > 1 && index < 7 ? 'bg-primary-400' : ''}
        ${index >= 7 ? 'bg-primary-300' : ''}
        `}
      >
        <div className="m-auto text-xs text-center text-white">{keywordLabelShort}</div>
      </div>
    </VoxelTooltipShort>
  );
});

export default KeywordAvatar;
